module.exports = __webpack_public_path__ + "img/en.f374400a.png";